export default {
  computed: {
    isMobile() {
      return this.$mq == 'sm' || this.$mq == 'md' ? true : false
    }    
  }
};
